interface DataErrorProps {
  error: unknown
  lang: 'el' | 'en'
  onRetry: () => void
}

export function DataError({ error, lang, onRetry }: DataErrorProps) {
  const detail = error instanceof Error ? error.message : null

  return (
    <div className="data-error" role="alert">
      <strong>{lang === 'en' ? 'Bus data is not available' : 'Τα δεδομένα λεωφορείων δεν είναι διαθέσιμα'}</strong>
      {detail && <span>{detail}</span>}
      <button type="button" onClick={onRetry}>
        {lang === 'en' ? 'Try again' : 'Δοκιμάστε ξανά'}
      </button>
    </div>
  )
}
